import styled, { keyframes, css } from 'styled-components';

interface StatuProps {
  status: string;
}

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(500px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
`;

const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(500px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 6;

  div::-webkit-scrollbar {
    display: none; /* Might be enough */
    background: transparent;
    visibility: hidden;
    width: 0px;
  }
  div {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
  }

  .active {
    opacity: 1;
    visibility: visible;
    right: 0px;
    animation: ${appearFromLeft} 0.5s;

    @media (max-width: 650px) {
      top: 0px;
      animation: ${appearFromTop} 0.5s;
    }
  }
`;

export const Content = styled.div`
  background: #fff;
  position: fixed;
  right: -450px;
  width: 700px;
  height: 100%;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  visibility: hidden;
  opacity: 0;
  border-radius: 3px;
  padding: 0 20px 20px;
  transition: all 0.5s ease-out;

  h1 {
    font-weight: 500;
  }
  h2 {
    margin-left: 10px;
    color: #455a64;
  }

  @media (max-width: 850px) {
    right: 0px;
    // top: 800px;
    width: 100%;
    margin-top: 0px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  position: fixed;
  padding: 10px 0;
  width: 100%;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--azul-razio);
    font-weight: 500;

    svg {
      font-size: 20px;
      margin-right: 5px;
    }
  }
`;

export const TituloContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 5px 10px 50px 10px;
  margin-top: 45px;

  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;

  hr {
    background-color: #cfd8dc;
    border: none;
    width: 100%;
    height: 1px;
    margin: 10px 0 10px 0;
  }

  @media (max-width: 880px) {
    margin-top: 35px;
  }
`;

export const TituloItem = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	border-bottom: 1px solid #d1d2dc;
	padding: 5px 0;

	span {
		color: #353646;
		font-weight: 500;
	}

	h2 {
		color: #455a64;
		padding-right: 10px;
		font-weight: 500;
	}

	&:first-child {
		padding-top: 0;
	}
	&:last-child {
		border-bottom: 0;
	}
`;
